
import { defineComponent } from "vue";

export default defineComponent({
  name: "ShiftDescriptionWidget",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
});
